import { WHOLE_BOOK_SPAN_ID } from "@/data/join-chapters";
import { writeTimelineSession } from "../TimelineSession/session";
import {
  readTimelineUiPreferences,
  writeTimelineUiPreferences,
} from "../TimelineUiPreferences/prefs";
import type { UrlOptions } from "./options";

const UNIVERSE_SESSION = "universe";

/** Applies an address's options on top of what this visitor had saved. */
export function applyUrlOptions(bookId: string, options: UrlOptions, pathSpanId?: string): void {
  const prefs = readTimelineUiPreferences();
  const spanId = pathSpanId ?? options.spanId ?? prefs.spanId;
  const journey = options.journey ?? prefs.journey;
  writeTimelineUiPreferences({
    ...prefs,
    journey,
    spanId,
    cameraLockEnabled: options.cameraLock ?? prefs.cameraLockEnabled,
    autoZoomEnabled: options.autoZoom ?? prefs.autoZoomEnabled,
  });
  if (options.atMs !== undefined) {
    writeTimelineSession({
      bookId,
      chapterId: journey === "universe" ? UNIVERSE_SESSION : spanId ?? WHOLE_BOOK_SPAN_ID,
      playheadMs: options.atMs,
      speed: 1,
      zoom: 1,
      panX: 0,
      panY: 0,
      heldZoom: null,
      panHeld: false,
    });
  }
}
